import {Component, Injector, Input} from '@angular/core';
import {Router} from '@angular/router';
import {BnLoadingService} from '@bndes/bndes-ux4/bndes-angular-utils';
import {BnModalMessageService} from '@bndes/bndes-ux4/bn-modal-message';
import {BnAlertsService} from '@bndes/bndes-ux4/bn-alerts';
import {BnMaskParser} from '@bndes/bndes-ux4/bn-mask/bn-mask-parser';
import moment from 'moment';
import {Observable} from 'rxjs';
import {PermissaoService} from 'src/app/shared/permissao.service';
import {RemoverAlertasService} from 'src/app/shared/services/remover-alertas.service';
import {QuestionarioService} from '../questionario.service';
import {
  DadosClienteDTO,
  MaquinasEquipamentosDTO,
  OpcaoQuestionarioRespostaEnergiaDTO,
  PerguntaEnergiaDTO,
  QuestionarioRespostaEnergiaDTO,
  ResponsavelAvaliacaoEconomiaDTO,
  TipoCustomizacaoEnum,
  TipoPerguntaEnum,
  TipoValorPerguntaEnum
} from '../../model/questionario.model';
import {DomSanitizer} from '@angular/platform-browser';
import {DatePipe} from '@angular/common';
import {Estado} from 'src/app/model/estado.model';

@Component({
    selector: 'app-questionario-revisao',
    templateUrl: './questionario-revisao.component.html',
    styleUrls: ['./questionario-revisao.component.scss'],
    standalone: false
})
export class QuestionarioRevisaoComponent {

    @Input()
    public listaPerguntas: PerguntaEnergiaDTO[];

    @Input()
    public respostas: QuestionarioRespostaEnergiaDTO[];

    @Input()
    public dadosCliente: DadosClienteDTO;

    @Input()
    public descricaoProjeto: string;

    @Input()
    public estado: Estado;

    @Input()
    public textoJustificativa: string | null = null;

    @Input()
    public usuarioAvaliadorFge$: Observable<Boolean>;

    @Input()
    public idQuestionario: number;

    exibeParteDeAcordo: Boolean;

    exibeResultadoDaAvaliacao: boolean = false;

    exibeTextoJustificativa: Boolean;

    situacaoAvaliacao: undefined | boolean = undefined;

    ehUsuarioAvaliadorFGE: boolean;

    categoriaEconomia = 'Bloco Economia';
    idPerguntaTecnica = 44;
    idRespostaPerguntaTecnicaTrue = 101;

    constructor(
        private modalService: BnModalMessageService,
        protected injector: Injector,
        private loadingService: BnLoadingService,
        private removerAlertasService: RemoverAlertasService,
        private alertsService: BnAlertsService,
        private sanitizer: DomSanitizer,
        private datePipe: DatePipe,
        private permissaoService: PermissaoService,
        private questionarioService: QuestionarioService,
        private router: Router) {
    }

    ngOnInit() {

        this.usuarioAvaliadorFge$.subscribe(resp => {
            this.ehUsuarioAvaliadorFGE = resp.valueOf();
        })

        this.exibeParteDeAcordo = this.ehUsuarioAvaliadorFGE && this.estado?.id == 1;

        this.exibeResultadoDaAvaliacao = this.ehUsuarioAvaliadorFGE && this.estado?.id == 1;

        this.exibeTextoJustificativa = this.estado?.id == 3;

        let idUltimoGrupo: number = -1;
        this.listaPerguntas.forEach(pergunta => {
            
            idUltimoGrupo = this.trataGrupoPergunta(pergunta, idUltimoGrupo);

            if (pergunta.tipoPergunta == TipoPerguntaEnum.ESCOLHA_UNICA) {
                let resposta = this.getRepostaPorPergunta(pergunta.id);
                pergunta.frontRespostaAsText = this.getRespostaFormatadaFromLista(pergunta, resposta?.conteudo, resposta?.conteudoComplementar);
            } else if ((pergunta.tipoPergunta == TipoPerguntaEnum.ESCOLHA_MULTIPLA) ||
                (pergunta.tipoPergunta == TipoPerguntaEnum.LISTA_COM_REDFLAG)) {

                let resposta = this.getRepostaPorPergunta(pergunta.id);
                pergunta.frontRespostaAsText = this.getRespostaFormatadaFromLista(pergunta, resposta?.conteudo, resposta?.conteudoComplementar);

            } else if (pergunta.tipoPergunta == TipoPerguntaEnum.TEXTO_LIVRE) {
                let resposta = this.getRepostaPorPergunta(pergunta.id);
                pergunta.frontRespostaAsText = this.getRespostaFormatadaFromText(pergunta, resposta?.conteudo);

            } else if (pergunta.tipoPergunta == TipoPerguntaEnum.PERSONALIZADA) {
                let resposta = this.getRepostaPorPergunta(pergunta.id);
                pergunta.frontRespostaAsText = this.getRespostaFormatadaPersonalizada(pergunta, resposta?.conteudo);
            }
        });

    }

    private getRepostaPorPergunta(idPergunta: number): QuestionarioRespostaEnergiaDTO {
        if (!this.respostas) {
            return null;
        }        

        for (let indResposta = 0; indResposta < this.respostas.length; indResposta++) {
            if (this.respostas[indResposta].idPergunta == idPergunta) {
                return this.respostas[indResposta];
            }
        }

        return null;
    }

    private getRespostaFormatadaFromText(pergunta: PerguntaEnergiaDTO, resposta: string): any {
        if (!resposta || resposta.length == 0) {
            return this.getRespostaNaoEncontrada();
        }

        let valorFormatado = '';
        let cnpjMask = new BnMaskParser('CNPJ');
        let moedaMask = new BnMaskParser('MOEDA');
        let cepMask = new BnMaskParser('CEP');


        if (pergunta.tipoValor == TipoValorPerguntaEnum.CNPJ) {
            valorFormatado = cnpjMask.aplicarMascara(resposta);
        } else if (pergunta.tipoValor == TipoValorPerguntaEnum.NUMERO_DECIMAL) {
            valorFormatado = moedaMask.aplicarMascara(resposta);
        } else if (pergunta.tipoValor == TipoValorPerguntaEnum.CEP) {
            valorFormatado = cepMask.aplicarMascara(resposta);
        } else if (pergunta.tipoValor == TipoValorPerguntaEnum.DATA) {
            valorFormatado = moment(resposta, 'YYYY-MM-DD').format('DD/MM/YYYY');
        } else {
            valorFormatado = resposta;
        }

        return `<div><b>Resposta:&nbsp;</b> &nbsp;${valorFormatado}</div>`;

    }

    private getRespostaFormatadaFromLista(pergunta: PerguntaEnergiaDTO, conteudo: any, conteudoComplementar: string): any {
        if (!conteudo) {
            return this.getRespostaNaoEncontrada();
        }

        let respostaFormatada = '';

        if (this.isString(conteudo)) {
            let listaRespostaSplit = conteudo.split(";");

            if (!listaRespostaSplit) {
                return this.getRespostaNaoEncontrada;
            }

            respostaFormatada += "<div><b>Resposta:&nbsp;</b>";
            for (let indResposta = 0; indResposta < listaRespostaSplit.length; indResposta++) {
                let itemResposta: string = this.getRespostaFromOpcoes(pergunta.listaOpcoes, Number(listaRespostaSplit[indResposta]), conteudoComplementar);
                respostaFormatada += `${itemResposta}`

                if (indResposta < listaRespostaSplit.length - 1) {
                    respostaFormatada += ', '
                }
            }
            respostaFormatada += "</div>";
        } else {

            let itemResposta: string = this.getRespostaFromOpcoes(pergunta.listaOpcoes, conteudo, conteudoComplementar);
            respostaFormatada += `<div><b>Resposta:&nbsp;</b> &nbsp;${itemResposta}</div>`;
        }

        return respostaFormatada;
    }

    private getRespostaFromOpcoes(listaOpcoes: OpcaoQuestionarioRespostaEnergiaDTO[], idOpcao: number, conteudoComplementar: string): string {
        let resp = '';
        for (let ind = 0; ind < listaOpcoes.length; ind++) {
            if (listaOpcoes[ind].id == idOpcao) {
                resp = listaOpcoes[ind].texto;
                if (listaOpcoes[ind].exigeTextoComplementar) {
                    resp += ` (${conteudoComplementar})`;
                }
            }
        }

        return resp;
    }

    private trataGrupoPergunta(pergunta: PerguntaEnergiaDTO, idUltimoGrupo: number): number {
        if (!pergunta.grupo) {
            return -1;
        }

        if (!idUltimoGrupo || idUltimoGrupo == -1 || idUltimoGrupo != pergunta.grupo.id) {
            idUltimoGrupo = pergunta.grupo.id;
            pergunta.frontIsPerguntaNovoGrupo = true;
        }

        return idUltimoGrupo;
    }

    private getRespostaNaoEncontrada(): any {
        return this.sanitizer.bypassSecurityTrustHtml('<div class="color-red fw-bold">Não respondido</div>');
    }


    private getRespostaFormatadaPersonalizada(pergunta: PerguntaEnergiaDTO, resposta: any): any {
        let respostaFormatada: string;
        let cnpjMask = new BnMaskParser('CNPJ');
        let cpfMask = new BnMaskParser('CPF');

        if (pergunta.tipoCustomizacao == TipoCustomizacaoEnum.RESPONSAVEL_PELA_AVALIACAO) {
            let obj: ResponsavelAvaliacaoEconomiaDTO = this.carregaResponsavelAvaliacao(pergunta, resposta);
            respostaFormatada = `
                <div><b>CNPJ: </b> ${cnpjMask.aplicarMascara(obj.cnpj)}</div>
                <div><b>CPF: </b> ${cpfMask.aplicarMascara(obj.cpf)}</div>
                <div><b>Nome: </b> ${obj.nome}</div>
                <div><b>Profissão: </b> ${obj.profissao}</div>
                <div><b>Número Registro Profissional: </b> ${obj.numeroRegistroProfissional}</div>
                <div><b>Órgão Registro: </b> ${obj.orgaoRegistro}</div>
            `;

            if (obj.unidadeFederacaoOrgao) {
                respostaFormatada += '<div><b>UF Órgão Registro: </b> ${obj.unidadeFederacaoOrgao}</div>';
            }
        }

         if (pergunta.tipoCustomizacao == TipoCustomizacaoEnum.MAQUINAS_EQUIPAMENTOS) {
            let valores: string = this.carregaListaMaquinasEquipamentos(resposta);
            respostaFormatada = `
                <div><b> ${valores} </b> </div>`;
        }

        return respostaFormatada
    }


    private carregaResponsavelAvaliacao(pergunta: PerguntaEnergiaDTO, conteudo: string): ResponsavelAvaliacaoEconomiaDTO {
        let conteudoSplit: string[] = conteudo.split(";")
        let obj: ResponsavelAvaliacaoEconomiaDTO = new ResponsavelAvaliacaoEconomiaDTO();
        for (let indCampo = 0; indCampo < conteudoSplit.length; indCampo++) {
            if (conteudoSplit[indCampo].startsWith('cnpj=')) {
                obj.cnpj = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else if (conteudoSplit[indCampo].startsWith('cpf=')) {
                obj.cpf = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else if (conteudoSplit[indCampo].startsWith('nome=')) {
                obj.nome = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else if (conteudoSplit[indCampo].startsWith('profissao=')) {
                obj.profissao = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else if (conteudoSplit[indCampo].startsWith('numeroRegistroProfissional=')) {
                obj.numeroRegistroProfissional = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else if (conteudoSplit[indCampo].startsWith('orgaoRegistro=')) {
                obj.orgaoRegistro = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else if (conteudoSplit[indCampo].startsWith('unidadeFederacaoOrgao=')) {
                obj.orgaoRegistro = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else {
                throw new Error("Campo inválido para a pergunta " + pergunta.id);
            }
        }

        return obj;
    }

   private carregaListaMaquinasEquipamentos(conteudo: string): string {
      if (conteudo && conteudo != '') {
          const obj = conteudo.split(';').map(item => JSON.parse(item) as MaquinasEquipamentosDTO);
          let valor: string = obj.map(item => item.quantidade + ' - ' + item.nomeItem).join(' <br/> ');
          return valor;
      }
    }

    private isString(value: any) {
        return typeof value === 'string' || value instanceof String;
    }

    rejeitar() {
        this.situacaoAvaliacao = false;
        this.exibeTextoJustificativa = true;
    }

    aprovar() {
        this.situacaoAvaliacao = true;
        this.exibeTextoJustificativa = false;
        this.textoJustificativa = null;
    }

    confirmar(id: number) {
        if (this.situacaoAvaliacao) {
            this.questionarioService.aprovarQuestionario(id).subscribe({
                next: () => {
                    this.alertsService.alertaSucesso('Sucesso','Questionário aprovado com sucesso!');
                },
                error: () => {
                    this.alertsService.alertaErro('Erro', 'Erro ao aprovar questionário');
                },
                complete: () => this.irParaPesquisa()
            })
        } else if(!this.situacaoAvaliacao) {
            this.questionarioService.reprovarQuestionario(id, this.textoJustificativa).subscribe({
                next: () => {
                    this.alertsService.alertaSucesso('Sucesso','Questionário reprovado com sucesso!');
                },
                error: () => {
                    this.alertsService.alertaErro('Erro', 'Erro ao reprovar questionário');
                },
                complete: () => this.irParaPesquisa()
            })
        }
    }

    irParaPesquisa() {
        this.router.navigate(['/questionario-fgenergia/pesquisa']);
    }

    desabilitarConfirmar(): boolean {
        return this.situacaoAvaliacao == undefined;
    }

    public isEmpresaTomadoraDiferente(): boolean {
        return this.dadosCliente.cnpjBeneficiario != null;
    }

    public podeMostrarQuestoesEconomia(): boolean {        
        const perguntaTecnica = this.respostas.find(resp => Number(resp.idPergunta) === this.idPerguntaTecnica);
        return this.respostas && Number(perguntaTecnica.conteudo) === this.idRespostaPerguntaTecnicaTrue;
    }

    public exibeRespostasDiferentesDoGrupoEconomia(pergunta: PerguntaEnergiaDTO): boolean {
        return pergunta.categoria != this.categoriaEconomia || Number(pergunta.id) === this.idPerguntaTecnica;
    }
    
    public exibeRespostasParaGrupoEconomia(pergunta: PerguntaEnergiaDTO): boolean {
        return pergunta.categoria === this.categoriaEconomia 
            && this.podeMostrarQuestoesEconomia() 
            && Number(pergunta.id) !== this.idPerguntaTecnica;
    }

}
